export default __webpack_public_path__ + "static/media/7.8f772416.jpg";